module.exports = __webpack_public_path__ + "media/icons/icon_bugyou-6c88b1ac.png";